export default {"src":"/_next/static/media/0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83.65e88311.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};